import { atom } from 'recoil';
import { Consent } from '../types/consent';

export const consentsAtom = atom<Array<Consent>>({
  key: 'core/consents',
  default: [],
});
